import React from 'react'
import styled from 'styled-components'
import { Text } from '../Text'
import { STYLES } from '../../static/style'
import { FieldUncheckedIcon } from '../Icon/FieldUncheckedIcon'
import { FieldCheckedIcon } from '../Icon/FieldCheckedIcon'

const StyledCheckbox = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0.5rem 0;
`

const HiddenCheckboxField = styled.input.attrs({
  type: 'checkbox',
})`
  display: none;
`

const StyledFieldCheckedIcon = styled(FieldCheckedIcon)``

const LabelText = styled(Text)`
  margin-left: ${STYLES.GUTTER};
  user-select: none;
`

interface ICheckboxProps {
  id?: string
  text?: string
  children?: React.ReactNode
  checked?: boolean
  onChange?: (ev: any, text?: string) => void
  className?: string
  labelStyle?: object
  name?: string
}

const Checkbox: React.FC<ICheckboxProps> = ({
  className,
  children,
  text,
  checked = false,
  labelStyle = {},
  onChange,
}) => (
  <StyledCheckbox className={className}>
    <HiddenCheckboxField
      checked={checked}
      onChange={(ev) => {
        onChange && onChange(ev, text)
      }}
    />
    {checked ? <StyledFieldCheckedIcon /> : <FieldUncheckedIcon />}
    <LabelText style={labelStyle}>{text || children}</LabelText>
  </StyledCheckbox>
)

export { Checkbox }
